/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Red_Bland_Hornet_NudgeInputs */

const fr_red_bland_hornet_nudge = /** @type {(inputs: Red_Bland_Hornet_NudgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max (m)`)
};

/**

* @param {Red_Bland_Hornet_NudgeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const red_bland_hornet_nudge = /** @type {((inputs?: Red_Bland_Hornet_NudgeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Red_Bland_Hornet_NudgeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_red_bland_hornet_nudge(inputs)
});